require('./hireCardVirtualCreditStep3.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const getExtension = require('utilities/mimeTypeToExt');

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const WebappRender = require('components/conditionalRender/webappRender');
const {
    CONFIRMATION_SCRIPT_AGREEMENT,
    CONFIRMATION_SCRIPT_GREETING,
    ConfirmationScript,
} = require('components/contactCenter/confirmScript/confirmationScript');
const CardLegalViewerModal = require('components/cards/cardLegalViewerModal/cardLegalViewerModal');
const ContactCenterValidationCards = require('components/hire/contactCenterValidationCards/contactCenterValidationCards');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// @constants
const {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_SYMBOL,
    EURO_TEXT,
    PERCENTAGE_SYMBOL,
    SECOND_STEP,
    THIRD_STEP,
    VIRTUAL_CREDIT_CARD_PRODUCT_STANDARD,
    VIRTUAL_CREDIT_CARD_PRODUCT_SUBTYPE,
    VIRTUAL_CREDIT_CARD_PRODUCT_TYPE,
} = require('constants/index');
const { VIRTUAL_CREDIT_PID } = require('constants/gdprPlacementIds');
const {
    messages: {VIRTUAL_CREDIT_HIRE_AND_GDPR},
    MULTIPLE_OPERATIONS,
    VIRTUAL_CREDIT_HIRE,
} = require('constants/operationTypes');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { VIRTUAL_CREDIT_CARD_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');
const { NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
class HireCardVirtualCreditStep3 extends React.Component {
    constructor(props) {
        super(props);
        this.handleDownloadPdf = this.handleDownloadPdf.bind(this);
        this.handleOnPrint = this.handleOnPrint.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
        this.handleYesNoSignedDocuments = this.handleYesNoSignedDocuments.bind(this)
        this.state = {
            precontractualMailProductInfo: {
                productName: VIRTUAL_CREDIT_CARD_PRODUCT_NAME,
                producto: VIRTUAL_CREDIT_CARD_PRODUCT_TYPE,
                standard: VIRTUAL_CREDIT_CARD_PRODUCT_STANDARD,
                subproducto: VIRTUAL_CREDIT_CARD_PRODUCT_SUBTYPE
            }
        };
    }

    componentDidMount() {
        const { sendPrecontractualDocumentMail, showIneAndRevolving } = this.props;
        const { precontractualMailProductInfo } = this.state;

        if (!showIneAndRevolving) {
            sendPrecontractualDocumentMail(precontractualMailProductInfo);
            if (!__CONTACT_CENTER__) {
                //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
                const termsAndConsText = [
                    formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText1'),
                    formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText1'),
                    formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText2'),
                    formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText2'),
                    formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText3'),
                ];
    
                this.props.setTermsAndCondsText(termsAndConsText.join(' '));
            }
        }
    }

    onHandleChangeCheckBox = (evt) => {
        const { handleAgreementCheckboxChange } = this.props;
        return handleAgreementCheckboxChange(evt, THIRD_STEP)
    }

    onHandleChangeCheckBoxCC = (evt) => {
        const { handleAgreementCheckboxChange } = this.props;
        return handleAgreementCheckboxChange(evt, THIRD_STEP)
    }
    
    buildLegalConfirmationSection(showRevolvingDocument, amount) {
        const {
            contractName,
            immHireCardVirtualCredit,
            sendMailParams,
            showIneAndRevolving,
            onHandleChangeCheckBoxCC,
            immFlagBasedFeatures,
            processEmail
        } = this.props;
        const { precontractualMailProductInfo } = this.state;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const immStep = immHireCardVirtualCredit.getIn(['steps', THIRD_STEP]);
        const agreementErrorMsg = formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxErrorMsg');
        const documentINE = immHireCardVirtualCredit.get('documentINE')
        const documentPolicy = immHireCardVirtualCredit.get('documentPolicy')
        const newIntLoading = documentINE && documentPolicy

        // Re-uses step 3 labels because they need to be the same as in step 3 but moved to step 1
        const agreementLinkUrl1 = formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkUrl1');
        const agreementLinkUrl2 = formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkUrl2');

        const agreementLabel = (
            <React.Fragment>
                <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText1" />
                &nbsp;
                <OKLink
                    modifier="emphasize"
                    onClick={() => this.onClickTealium('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText1')}
                    target="_blank"
                    to={agreementLinkUrl1}
                >
                    <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText1" />
                </OKLink>
                &nbsp;
                <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText2" />
                &nbsp;
                <OKLink
                    modifier="emphasize"
                    onClick={() => this.onClickTealium('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText2')}
                    target="_blank"
                    to={agreementLinkUrl2}
                >
                    <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText2" />
                </OKLink>
                &nbsp;
                <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText3" />
            </React.Fragment>
        );
        if (newCardsFF) {
            return (
                <ContactCenterValidationCards
                    amount={amount}
                    agreementErrorMsg={agreementErrorMsg}
                    agreementLabel={agreementLabel}
                    contractName={contractName}
                    handleAgreementCheckboxChange={this.onHandleChangeCheckBox}
                    isContractingProcess
                    immStep={immStep}
                    precontractualMailProductInfo={precontractualMailProductInfo}
                    sendMailParams={sendMailParams}
                    showIneAndRevolving={showIneAndRevolving}
                    showRevolvingDocument={showRevolvingDocument}
                    processEmail={processEmail}
                    immHireCardOpenCredit={immHireCardVirtualCredit}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    ineNotCall={newCardsFF}
                    newIntLoading={newIntLoading}
                    newCardsFF={newCardsFF}
                />
            );
        }else{
            return (
                <ContactCenterValidationCards
                    amount={amount}
                    agreementErrorMsg={agreementErrorMsg}
                    agreementLabel={agreementLabel}
                    contractName={contractName}
                    handleAgreementCheckboxChange={this.onHandleChangeCheckBox}
                    isContractingProcess
                    immStep={immStep}
                    precontractualMailProductInfo={precontractualMailProductInfo}
                    sendMailParams={sendMailParams}
                    showIneAndRevolving={showIneAndRevolving}
                    showRevolvingDocument={showRevolvingDocument}
                    processEmail={processEmail}
                    immHireCardOpenCredit={immHireCardVirtualCredit}
                    onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                    ineNotCall={newCardsFF}
                    newIntLoading={newIntLoading}
                    newCardsFF={newCardsFF}
                />
            );
        }
        
    }

    handleYesNoSignedDocuments(value) {
        const { printedAndSignedRadioChanged, enableButtonOffice, checkRadioButtonPolicy } = this.props

        checkRadioButtonPolicy(value === 'yes' ? true : false)
    }

    buildSummary() {
        const {
            immAccounts,
            immHireCardNameSelector,
            immHireCardVirtualCredit,
            immHireCreditLimit,
            immHirePaymentMethod,
        } = this.props;

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardVirtualCredit-hireCardVirtualCredit_summaryMethodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardVirtualCredit-hireCardVirtualCredit_summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardVirtualCredit-hireCardVirtualCredit_summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = paymentMethod[paymentMethodType];
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL : PERCENTAGE_SYMBOL;
        let paymentMethodValue;

        if (paymentMethodType !== CARD_PAYMENT_METHOD_UNIQUE) {
            const limitPaymentsAmount = {
                amount: immHirePaymentMethod.get('value'),
                currency: paymentMethodSymbol
            };
            paymentMethodValue = (
                <OneLineSymbolAmount
                    amountObject={limitPaymentsAmount}
                    language={getLanguage()}
                    amountObjectFormatted={formatAmountObject(limitPaymentsAmount, true)}
                    trimDecimals={true}
                />
            );
        }

        const selectedAccount = immHireCardVirtualCredit.getIn(['steps', SECOND_STEP, 'accountId']);
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="hire-card-virtual-credit-step-three__summary row">
                <div className="col-xs-6">
                    <FormattedText
                        className="hire-card-virtual-credit-step-three__summary-label"
                        value="hireCardVirtualCredit-hireCardVirtualCredit_summarySelectedName"
                    />
                    <div className="hire-card-virtual-credit-step-three__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-6">
                    <FormattedText
                        className="hire-card-virtual-credit-step-three__summary-label"
                        value="hireCardVirtualCredit-hireCardVirtualCredit_summarySelectedLimit"
                    />
                    <div className="hire-card-virtual-credit-step-three__summary-value--highlight">
                        <OneLineSymbolAmount
                            amountObject={limitObj}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(limitObj, true)}
                            trimDecimals={true}
                        />
                    </div>
                </div>
                <div className="col-xs-6">
                    <FormattedText
                        className="hire-card-virtual-credit-step-three__summary-label"
                        value="hireCardVirtualCredit-hireCardVirtualCredit_summaryPaymentMethod"
                    />
                    <div className="hire-card-virtual-credit-step-three__summary-value">
                        {paymentMethodText} {paymentMethodValue}
                    </div>
                </div>
                <div className="col-xs-6">
                    <FormattedText
                        className="hire-card-virtual-credit-step-three__summary-label"
                        value="hireCardVirtualCredit-hireCardVirtualCredit_asociatedAccount"
                    />
                    <div className="hire-card-virtual-credit-step-three__summary-value">
                        {`${immAccount.get('alias')} ${accountIban}`}
                    </div>
                </div>
            </div>
        );
    }

    blockInfo() {
        const { operativeName } = this.props;
        return (

            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check block-info" hasCheckbox>
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={formatText(operativeName)}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                </ContactCenterRender>

            </BlockInfo>
        );
    }
    
    openPdfInNewTab(documentKey) {
        const { immHireCardVirtualCredit } = this.props;
        const document = immHireCardVirtualCredit.get(documentKey);
        const contentType = "application/pdf";
        const pdf = `data:${contentType};base64,${document}`;
        if (document) {
            openBase64pdfInPrintWindow(pdf, true);
        }
    }

    handleOpenPdfINENewTab() {
        this.openPdfInNewTab('documentINE');
    }

    handleOpenPdfDIRNewTab() {
        this.openPdfInNewTab('documentDIR');
    }

    buildPdfLink() {
        const { immHireCardVirtualCredit } = this.props;
        const documentDIR = immHireCardVirtualCredit.get('documentDIR');
        return (
            <>
                <div>
                    <h4 className="contract-loan-pdf-viewer__subtitle">
                        <strong>
                            <FormattedText value={`overdraftProtectionLoan-subtitleConfirmPage`} />
                        </strong>
                    </h4>
                    <div className="contract-actions-readed contract-payrollLoan-readed">
                        <button className="link--red option-link-cards-color-blue" onClick={() => this.handleOpenPdfINENewTab()}>
                            <FormattedText value={'hireCardOpenCredit-hireCardOpenCredit_legalText'} />
                        </button>
                        <span>
                            <i className="signature-pattern-code-input__icon icon icon-check" />
                            <FormattedText className="signature-text" value={'hireCardOpenCredit-hireCardOpenCredit_legalTextRead'} />
                        </span>
                    </div>
                    {documentDIR && (
                        <div className="contract-actions-readed contract-payrollLoan-readed">
                            <button className="link--red option-link-cards-color-blue" onClick={() => this.handleOpenPdfDIRNewTab()}>
                                <FormattedText value={'hireCreditCard-documentNameDir'} />
                            </button>
                            <span>
                                <i className="signature-pattern-code-input__icon icon icon-check" />
                                <FormattedText className="signature-text" value={'hireCardOpenCredit-hireCardOpenCredit_legalTextRead'} />
                            </span>
                        </div>
                    )}
                </div>

            </>
        )
    }

    handleOnPrint() {
        const { hireCardVirtualCreditprintDocument, immHireCardVirtualCredit, hireCardVirtualCreditprintDocumentPolicy } = this.props;
        const documentINE = immHireCardVirtualCredit.get('documentPolicy');


        if (documentINE) {
            const base64 = documentINE;
            const contentType = "application/pdf";
            const pdf = `data:${contentType};base64,${base64}`;
            const data = [base64ToBlob(pdf)];
            const blobObject = new Blob(data, { type: `${contentType};base64` });
            const blobURL = URL.createObjectURL(blobObject);
            const winparams = `dependent=yes,locationbar=no,scrollbaars=yes,menubar=yes,resizable,screenX=50,screenY=50,width=${screen.width},height=${screen.height}`;
            const printWindow = window.open(blobURL, '', winparams);
            isPrintOfficeMode() ? hireCardVirtualCreditprintDocumentPolicy() : hireCardVirtualCreditprintDocument()
            if (printWindow) {
                printWindow.print();
            }

        }
    }
    
    handleDocumentReaded() {
        const { cardsConfimationScrollDownPolicy } = this.props;
        cardsConfimationScrollDownPolicy();
    }

    handleDownloadPdf() {
        const { immHireCardVirtualCredit } = this.props;

        const documentINE = immHireCardVirtualCredit.get('documentPolicy');
        const base64 = documentINE;
        const contentType = "application/pdf";
        const pdf = `data:${contentType};base64,${base64}`;
        let fileName = formatText(`hireCardOpenCreditStepPolicy-pdfDownload`) + "." + getExtension(contentType);
        downloadAsFile(base64ToBlob(pdf), contentType, fileName);

    }

    buildViewer() {
        const { immHireCardVirtualCredit } = this.props;

        const documentINE = immHireCardVirtualCredit.get('documentPolicy');
        if (documentINE) {
            let title = isPrintOfficeMode() ? formatText(`hireCardOpenCreditStepPolicy-titlePdfOffice`) : formatText(`hireCardOpenCreditStepPolicy-titlePdfWP`);
            const scale = 1.05;
            const viewerHeight = 480;
            const base64 = documentINE;
            const contentType = "application/pdf";
            const document = `data:${contentType};base64,${base64}`;

            return (
                <OKPdfViewer
                    onDownload={this.handleDownloadPdf}
                    pdfFile={document}
                    scale={scale}
                    viewerHeight={viewerHeight}
                    onPrint={this.handleOnPrint}
                    title={title}
                    showScroll
                    onScroll={this.handleOnScroll}
                    onDocumentReaded={this.handleDocumentReaded}
                />
            );
        } else {
            return <LoadingSection />;
        }
    }

    blockInfoOffice() {
        return (
            <BlockInfo extraClass="contract-payroll-loan-step-two__block-check hire-card-open-credit-step-five__block-info-officine" hasCheckbox>
                <strong><FormattedText value="hireCardOpenCreditStep5-blockInfoOficineTitle" /></strong>
                <br />
                <br />
                <FormattedText value="hireCardOpenCreditStep5-blockInfoOficineSubTitle" />
            </BlockInfo>
        );
    }

    render() {
        const {
            handleAgreementCheckboxChange,
            immHireCardVirtualCredit,
            immHireCreditLimit,
            immPdfData,
            operativeName,
            printTitleValue,
            showIneAndRevolving,
            immHirePaymentMethod,
            immFlagBasedFeatures
        } = this.props;
        const newCardsFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES);
        const { precontractualMailProductInfo } = this.state;
        const params = {};
        const immStep = immHireCardVirtualCredit.getIn(['steps', THIRD_STEP]);
        const agreementLabel = <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText" />;
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementChecked = (__CONTACT_CENTER__ && !showIneAndRevolving ? true : immStep.get('agreementChecked'));
        const agreementErrorMsg = formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxErrorMsg');
        const operationProcessId = immHireCardVirtualCredit.get('operationProcessIdInitPolicy')
        const multipleSignaturePatternParams = [{ serviceCode: VIRTUAL_CREDIT_HIRE }];
        const pdfError = immPdfData.get('errorContent');
        const summaryContent = this.buildSummary();
        const operative = (__CONTACT_CENTER__ && operativeName) ? formatText(operativeName) : '';
        const paymentMethodType = immHirePaymentMethod.get('type');
        const showRevolvingDocument = paymentMethodType !== CARD_PAYMENT_METHOD_UNIQUE;

        const preContractDocumentInfo = getCardsPreContractPdfData()['virtual_credit'];
        let agreementCheckboxContent, GDPRSignaturePatternContent;
        const amount = immHireCreditLimit.get('creditLimit');
        const legalConfirmationSection = this.buildLegalConfirmationSection(showRevolvingDocument, amount);
        const blockInfo = isPrintOfficeMode() && this.blockInfo();
        const agreeIneCheckbox = immHireCardVirtualCredit.get('agreeIneCheckbox')
        const pdfLink = newCardsFF ? this.buildPdfLink() : null
        const PDFDcocument = this.buildViewer();
        const blockInfoOffice = isPrintOfficeMode() ? this.blockInfoOffice() : null;
        if(!pdfError && !showIneAndRevolving) {
            agreementCheckboxContent = (
                <div className="hire-card-virtual-credit-step-three__checkbox-container">
                    <WebappRender>
                        <OKCheckbox
                            idName="hireCardVirtualCreditAgreementCheckbox"
                            errorState={agreementErrorVisible}
                            errorMessage={agreementErrorMsg}
                            label={agreementLabel}
                            onChange={handleAgreementCheckboxChange}
                            value={agreementChecked}
                        />
                    </WebappRender>
                </div>
            )
        }

        if(agreementChecked) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={VIRTUAL_CREDIT_HIRE}
                    operationParams={params}
                    multiOTPMessageCode={VIRTUAL_CREDIT_HIRE_AND_GDPR}
                    printTitleValue={printTitleValue}
                    newOperationProcessId={operationProcessId}
                />
            )
        }

        if(agreeIneCheckbox) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={multipleSignaturePatternParams}
                    multiOTPMessageCode={VIRTUAL_CREDIT_HIRE_AND_GDPR}
                    newOperationProcessId={operationProcessId}
                    isEasyLoanTypeAB={isPrintOfficeMode() && true}
                />
            )
        }
        if (newCardsFF) {
            if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
                return (
                    <article className="hire-card-virtual-credit-step-three">
                        <FormattedText
                            className="hire-card-virtual-credit__step-title"
                            value="hireCardVirtualCredit-hireCardVirtualCredit_step3Title"
                        />
                    <FormattedText
                            className="hire-card-virtual-credit-step-three__subtitle"
                            value="hireCardVirtualCredit-hireCardVirtualCredit_step3Subtitle"
                        />
                        <br />
                        {summaryContent}
                        <OKConsents placementId={VIRTUAL_CREDIT_PID} />
                        <div className="hire-card-virtual-credit-step-three__pdf-viewer-container">
                            {pdfLink}
                            <br />
                            <div className="hire-card-open-credit-step-five__summary-label">
                                <FormattedText value="hireCardOpenCredit-infoLink" />
                            </div>
                            <br />
                            {blockInfoOffice}
                            <br />
                            {PDFDcocument}                            
                        </div>
                        {GDPRSignaturePatternContent}
                    </article>
                );
            }else{
                return (
                    <article className="hire-card-virtual-credit-step-three">
                    <FormattedText
                        className="hire-card-virtual-credit__step-title"
                        value="hireCardVirtualCredit-hireCardVirtualCredit_step3Title"
                    />
                    <FormattedText
                            className="hire-card-virtual-credit-step-three__subtitle"
                            value="hireCardVirtualCredit-hireCardVirtualCredit_step3Subtitle"
                        />
                    {blockInfo}
                    <br />
                    {summaryContent}
                    <OKConsents placementId={VIRTUAL_CREDIT_PID} />
                    <WebappRender>
                        <div className="hire-card-virtual-credit-step-three__pdf-viewer-container">
                            {pdfLink}
                            <br />
                            <div className="hire-card-open-credit-step-five__summary-label">
                                <FormattedText value="hireCardOpenCredit-infoLink" />
                            </div>
                            <br />
                            {PDFDcocument}
                            <br />
                        </div>
                    </WebappRender>
                    {agreementCheckboxContent}
                    <ContactCenterRender>
                        {showIneAndRevolving ?
                            legalConfirmationSection
                            :<ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                        }
                    </ContactCenterRender>
                    {GDPRSignaturePatternContent}
                </article>
            );  
            }
        }else{
            return (
                <article className="hire-card-virtual-credit-step-three">
                    <FormattedText
                        className="hire-card-virtual-credit__step-title"
                        value="hireCardVirtualCredit-hireCardVirtualCredit_step3Title"
                    />
                    <ConfirmationScript
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        operative={operative}
                    />
                    <FormattedText
                        className="hire-card-virtual-credit-step-three__subtitle"
                        value="hireCardVirtualCredit-hireCardVirtualCredit_step3Subtitle"
                    />
                    {blockInfo}
                    <br />
                    {summaryContent}
                    <OKConsents placementId={VIRTUAL_CREDIT_PID} />
                    <WebappRender>
                        <div className="hire-card-virtual-credit-step-three__pdf-viewer-container">
                            {showIneAndRevolving ?
                                <CardLegalViewerModal
                                    amount={amount}
                                    agreeCheckboxRevol={agreementChecked}
                                    handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                                    isContractingProcess
                                    precontractualMailProductInfo={precontractualMailProductInfo}
                                    showRevolvingDocument={showRevolvingDocument}
                                />
                                : <PreContractualDocumentViewer
                                    preContractDocumentInfo={preContractDocumentInfo}
                                    titleKey="preContractDocument_pdfTitleINE"
                                />
                            }
                        </div>
                    </WebappRender>
                    {agreementCheckboxContent}
                    <ContactCenterRender>
                        {showIneAndRevolving ?
                            legalConfirmationSection
                            :<ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                        }
                    </ContactCenterRender>
                    {GDPRSignaturePatternContent}
                </article>
            );
        }

    }
}

HireCardVirtualCreditStep3.propTypes = {
    contractName: PropTypes.string,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardVirtualCredit: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    operativeName: PropTypes.string,
    printTitleValue: PropTypes.string,
    sendMailParams: PropTypes.object,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    showIneAndRevolving: PropTypes.bool,
};

module.exports = HireCardVirtualCreditStep3;
